import gql from 'graphql-tag';

import conversationFragment from './conversationFragment';
import dokkioTagFragment from './dokkioTagFragment';
import dokkioUserFragment from './dokkioUserFragment';
import integrationItemFragment from './integrationItemFragment';
import integrationEmailFragment from './integrationEmailFragment';
import integrationThreadFragment from './integrationThreadFragment';
import webpageFragment from './webpageFragment';

export const mainDisplayObjectFragment = gql`
  fragment mainDisplayObjectFragment on MainDisplayObject {
    ...conversationFragment
    ...dokkioTagFragment
    ...dokkioUserFragment
    ...integrationItemFragment
    ...integrationEmailFragment
    ...integrationThreadFragment
    ...webpageFragment
  }
  ${conversationFragment}
  ${dokkioTagFragment}
  ${dokkioUserFragment}
  ${integrationItemFragment}
  ${integrationEmailFragment}
  ${integrationThreadFragment}
  ${webpageFragment}
`;
export default mainDisplayObjectFragment;
